module.exports = __webpack_public_path__ + "static/media/serviceimg_01.5d6f0a8f.svg";